import { render } from "./search.vue?vue&type=template&id=82f81aec"
import script from "./search.vue?vue&type=script&lang=js"
export * from "./search.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/other/iframe/search.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "82f81aec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('82f81aec', __exports__)) {
    console.log('reload')
    api.reload('82f81aec', __exports__)
  }
  
  module.hot.accept("./search.vue?vue&type=template&id=82f81aec", () => {
    console.log('re-render')
    api.rerender('82f81aec', render)
  })

}


export default __exports__